export default __webpack_public_path__ + "4ff1d2f148fd8880e536c3e228192daf.png";